export default __webpack_public_path__ + "static/media/garbage-can.1c7a0804.svg";